var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_reflection"
  }, [_c('Row', {
    staticClass: "adr_heard"
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.leftTitle))])]), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v(" " + _vm._s(_vm.rightTitle) + " ")])], 1), _c('Tree', {
    staticClass: "adr_tree",
    attrs: {
      "emptyText": $t("dcv57g4", "暂无数据"),
      "select-node": false,
      "data": _vm.treeData,
      "render": _vm.renderContent
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };